import MLink from '@mui/material/Link';
import { makeStyles } from 'tss-react/mui';
import Person from '@mui/icons-material/Person';
import UrlLink from './url-link';
import MaterialLink from './material-link';
import { instagramUrl } from '../utils/urls';
import type { City } from '../types/City';

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    marginBottom: theme.spacing(2),
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(2)
    },
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(0.5, 0),
  },
  metaIcon: {
    marginRight: theme.spacing(0.5),
    opacity: 0.6,
    fontSize: 20,
  },
  metaIconSvg: {
    width: 16,
    height: 16,
    marginRight: theme.spacing(1),
    opacity: 0.6,
  },
  inline: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(2),
    }
  },
  compact: {
    marginBottom: 0,
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(1),
    },
    '& $item': {
      margin: 0,
    },
  },
  small: {
    fontSize: '0.875rem',
    '& a': {
      fontSize: 'inherit',
    },
  },
}));

type SocialLinksSource = {
  websiteUrl?: string;
  instagramUsername?: string;
  pronouns?: string;
  city?: City;
};

type Props = {
  source?: SocialLinksSource;
  inline?: boolean;
  compact?: boolean;
  small?: boolean;
};

const SocialLinks = ({ source, inline = false, compact = false, small = false }: Props) => {
  const { classes, cx } = useStyles();

  if (!source.websiteUrl && !source.instagramUsername && !source.city && !source.pronouns) {
    return null;
  }

  return (
    <div className={cx(classes.wrapper, { [classes.inline]: inline, [classes.compact]: compact, [classes.small]: small })}>
      {source.pronouns && (
        <div className={classes.item}>
          <Person className={classes.metaIcon} />
          {source.pronouns}
        </div>
      )}
      {source.websiteUrl && (
        <div className={classes.item}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/static/link-solid.svg" alt="" className={classes.metaIconSvg} />
          <UrlLink url={source.websiteUrl} />
        </div>
      )}
      {source.instagramUsername && (
        <div className={classes.item}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/static/instagram-brands.svg" alt="" className={classes.metaIconSvg} />
          <MLink
            href={instagramUrl(source.instagramUsername)}
            rel="noopener noreferrer"
          >
            @{source.instagramUsername.replace(/^@/, '')}
          </MLink>
        </div>
      )}
      {source.city && (
        <div className={classes.item}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/static/globe-americas-solid.svg" alt="" className={classes.metaIconSvg} />
          <MaterialLink
            href={`/cities/${source.city.slug}`}
            title={`${source.city.name}, ${source.city.locality}`}
          >
            {source.city.name}
          </MaterialLink>
        </div>
      )}
    </div>
  );
};

export default SocialLinks;
